// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"737c2378","890":"c333fc15"}[chunkId] + ".chunk.js";
};